import ReceivablesLayout from '@/apps/payin/Layout';
import ReceivablesPage from '@/apps/payin/receivables/pages/ReceivablesPage.vue';
import PaymentLinkPage from '@/apps/payin/paymentLink/Pages/PaymentLinkPage.vue';
import PaymentLinkListPage from '@/apps/payin/paymentLink/Pages/PaymentLinkListPage.vue';
import checkpoint from '@/commons/constants/checkpoint';
import checkpointResource from '@/commons/resources/checkpoint';
import { APPS } from '@/commons/constants/apps';
import { hasFeatureFlag } from '@/commons/services/featureFlags';

export default {
  path: '/recebimentos',
  component: ReceivablesLayout,
  name: 'Receivables',
  redirect: {
    name: 'ReceivablesPage'
  },
  beforeEnter: () => {
    const payinFeatureFlag = hasFeatureFlag('payin');
    if (!payinFeatureFlag) {
      return '/pagamentos/lotes';
    }
    checkpointResource.create(checkpoint.PAYIN_PAGE_VIEWED);
  },
  children: [
    {
      path: 'recebiveis',
      component: ReceivablesPage,
      name: 'ReceivablesPage'
    },
    {
      path: 'links-de-pagamento',
      component: PaymentLinkListPage,
      name: 'PaymentLinkListPage',
      beforeEnter: () => {
        const payinFeatureFlag = hasFeatureFlag('payment-link');
        if (!payinFeatureFlag) {
          return '/recebimentos/recebiveis';
        }
        checkpointResource.create(checkpoint.PAYMENT_LINK_LIST_PAGE_VIEWED);
      }
    },
    {
      path: 'links-de-pagamento/novo',
      component: PaymentLinkPage,
      name: 'PaymentLinkPage',
      beforeEnter: () => {
        const payinFeatureFlag = hasFeatureFlag('payment-link');
        if (!payinFeatureFlag) {
          return '/recebimentos/recebiveis';
        }
        checkpointResource.create(checkpoint.PAYMENT_LINK_CREATION_PAGE_VIEWED);
      }
    }
  ].map(route => ({
    ...route,
    meta: {
      ...route.meta,
      authAs: APPS.PAYMENTS.key
    }
  }))
};
